// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ovfg","tabsBox":"styles_tabsBox__3uyIS","createButton":"styles_createButton__OihQz"};